import { Icon } from '../Icon.js';

/** A list's search box: the glass says what it is, the label says it to a reader. */
export function SearchField({
  value,
  onChange,
  placeholder,
  label,
  testId,
  id,
}: {
  value: string;
  onChange: (next: string) => void;
  placeholder: string;
  label: string;
  testId: string;
  id?: string;
}) {
  return (
    <label className="ui-search">
      <Icon name="search" size={15} />
      <input
        id={id}
        type="search"
        value={value}
        placeholder={placeholder}
        aria-label={label}
        data-testid={testId}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      />
    </label>
  );
}
